<template>
  <div class="step-two">
    <div class="step-two__wrapper">
      <InsuranceTariffsList
        class="step-two__cards"
        :tariffs-sum="tariffsSum"
        :tariff-go="tariffGo"
        :use-titul="useTitul"
        :prem-sum-go="premSumGo"
        :form-data="formData"
        @tariff-chosen="handleTariff"
        @change-tariff-go="handleTariffGo"
        @change-use-titul="handleUseTitul"
        @mounted="mountedHandler"
      />
    </div>
  </div>
</template>

<script>
import InsuranceTariffsList from '@/components/pages/index/InsuranceProcess/InsuranceTariffsList';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import BaseButton from "@/components/ui/BaseButton.vue";

export default {
  name: 'Step2',
  components: {
    BaseButton,
    ResultCard,
    InsuranceTariffsList
  },
  props: {
    tariffsSum: Object,
    formData: Object,
    discountPercent: Number,
    resultId: Number,
    premSumGo: Number,
    tariffGo: Number | null,
    useTitul: Boolean,
  },
  data() {
    return {
      tariffs: [],
    }
  },
  computed: {

  },
  methods: {
    mountedHandler(tariffs) {
      this.$emit('mounted', tariffs)
    },
    handleTariff(tariffs) {
      this.$emit('tariff-chosen', tariffs)
    },
    handleTariffGo(value) {
      this.$emit('change-tariff-go', value)
    },
    handleUseTitul(value) {
      this.$emit('change-use-titul', value)
    },
  },
}
</script>
<style scoped lang="scss">
.step-two {
  &__wrapper {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }

  &__result {
    height: 100%;
  }
}
</style>
